import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { FC } from 'react';
import styles from '../../styles.module.scss';

const cx = classnames.bind(styles);
export const PaymentDueDateContent: FC<{
  paymentDueMonth?: string;
  paymentDueDate?: string;
}> = ({ paymentDueMonth, paymentDueDate }) => {
  const { t } = useTranslation();

  return (
    <div className={cx('dynamicTextContainer')}>
      <div className={cx('singleLineText')}>
        {t('ap_payee_detail_drawer_payment_rule_payment_due_date_content')}
        <span>{paymentDueMonth}</span>
        {t('ap_payee_detail_drawer_payment_rule_payment_due_date_of')}
        <span>{paymentDueDate}</span>
      </div>
    </div>
  );
};

PaymentDueDateContent.displayName = 'PaymentDueDateContent';
